import http from "@/http";
import eventBus from "@/events";

const Driver = {
    findAll: async function (ctx) {
        if(ctx) {
            const page = ctx.currentPage - 1 || 0;
            const size = ctx.perPage || 20;
            const sortDesc = ctx.sortDesc ? ',desc' : '';
            const sort = (ctx.sortBy || 'employeeNumber') + sortDesc;
            const filter = ctx.filter ? ctx.filter : {};
            const pagination = {page, size, sort, sortDesc};
            const params = {...filter, ...pagination};
            const resp = await http("/drivers/search/all", {params});
            eventBus.$emit('LIST_COUNT_DRIVER_EVENT', resp.data.page.totalElements);
            return resp.data._embedded.drivers;
        } else {
            const resp = await http("/drivers/search/all");
            eventBus.$emit('LIST_COUNT_DRIVER_EVENT', resp.data.page.totalElements);
            return resp.data._embedded.drivers;
        }
    },
    create: function(data) {
        return http.post('/drivers', data);
    },
    update: function (id, data) {
        return http.patch('/drivers/' + id, data);
    },
    findById(id) {
        return http.get('/drivers/' + id);
    },
    enable(id) {
        return http.patch('/drivers/' + id + '/enable')
    },
    disable(id) {
        return http.patch('/drivers/' + id + '/disable')
    },
    deleteById(id) {
        return http.delete('/drivers/' + id)
    },
    findCompany: function(id) { return http.get('undefined'.replace('{id}', id)); },nationalityExists(nationality) {
        return http.get("/drivers/exists/nationality", {params: {nationality: nationality}}).then(x => {
            return !x.data;
        });
    }
};

export default Driver;
